"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createElement_1 = require("../dom/createElement");
class ModalService {
    constructor() {
        this.previousModal = null;
        this.modalParent = (0, createElement_1.createElement)('<div class="modal modal_hidden"> </div>');
        this.overlay = (0, createElement_1.createElement)('<div class="modal__overlay"></div>');
        this.overlay.addEventListener('click', () => {
            this.close();
        });
        this.content = (0, createElement_1.createElement)('<div class="modal__content"></div>');
        this.modalParent.append(this.overlay);
        this.modalParent.append(this.content);
        document.body.prepend(this.modalParent);
    }
    open(element) {
        var _a;
        (_a = this.previousModal) === null || _a === void 0 ? void 0 : _a.remove();
        this.previousModal = element;
        this.content.append(element);
        this.modalParent.classList.remove('modal_hidden');
    }
    close() {
        var _a;
        (_a = this.previousModal) === null || _a === void 0 ? void 0 : _a.remove();
        this.previousModal = null;
        this.modalParent.classList.add('modal_hidden');
    }
}
exports.default = ModalService;
